// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .wrapper {
  position: relative;
  width: 100%;
}

.pickerWrapper {
  position: absolute;
  top: -70px;
  left: 0;
  right: 0;
  background: rgba(14, 7, 26, 0.83);
  border-radius: 16px;
  backdrop-filter: blur(10px);
  padding: 16px;
  z-index: 100;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
} */
`, "",{"version":3,"sources":["webpack://./src/components/TimeWheelPicker/TimeInputWrapper.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;GAgBG","sourcesContent":["/* .wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.pickerWrapper {\n  position: absolute;\n  top: -70px;\n  left: 0;\n  right: 0;\n  background: rgba(14, 7, 26, 0.83);\n  border-radius: 16px;\n  backdrop-filter: blur(10px);\n  padding: 16px;\n  z-index: 100;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
